import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getDeliveryWindows } from '../../../services/OrdersService';
import { DELIVERY_WINDOWS_FALLBACK } from './deliveryStatusConstants';

// The three fixed delivery time windows as a required single choice (no free typing). Keys and hours come from the backend
// (GET /api/delivery-windows, one definition in services/delivery_windows.py); the names and the "between … and …" wording are the
// admin locale files'. `idPrefix` keeps the radio ids unique when more than one group is on a page.
export default function DeliveryWindowSelect({ value, onChange, isInvalid, idPrefix = 'delivery-window' }) {
    const { t } = useTranslation();
    const [windows, setWindows] = useState(DELIVERY_WINDOWS_FALLBACK);

    useEffect(() => {
        let cancelled = false;
        Promise.resolve()
            .then(() => getDeliveryWindows())
            .then((res) => {
                if (!cancelled && res && Array.isArray(res.data) && res.data.length) setWindows(res.data);
            })
            .catch(() => {});
        return () => { cancelled = true; };
    }, []);

    return (
        <Form.Group className="mb-3" data-testid="delivery-window-group">
            <Form.Label>{t('deliveryWindows.label')} <span className="text-danger">*</span></Form.Label>
            {windows.map((w) => (
                <Form.Check
                    key={w.key}
                    type="radio"
                    name={idPrefix}
                    id={`${idPrefix}-${w.key}`}
                    value={w.key}
                    checked={value === w.key}
                    onChange={() => onChange(w.key)}
                    isInvalid={isInvalid}
                    label={t('deliveryWindows.option', {
                        name: t(`deliveryWindows.names.${w.key}`),
                        between: t('deliveryWindows.between', { start: w.start, end: w.end }),
                    })}
                />
            ))}
            {isInvalid && <div className="text-danger small">{t('deliveryWindows.required')}</div>}
        </Form.Group>
    );
}
